export default __webpack_public_path__ + "static/Cta-mobile-8094dc81b7e13e40371dc33f5b43f70c.jpg";